module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/qshou1-6dc107d9f744835cd24685c8e6c1dab2.jpg";